import React from 'react';
import { BRAND_ASSETS } from '../../config/defaultAssetUrls';
import { HorizontalSeparator } from '../common/Separator';
import useRouting from '../../hooks/useRouting';
import { useLocation } from 'react-router-dom';
import { CHAT_ROUTE } from '../../App';
import useCurrentUser from '../../hooks/useCurrentUser';
import { EUserType } from '../../data_models/enums';

const Footer: React.FC = () => {

    const { goToPartnersAndAffiliates, goToPricing } = useRouting();
    const location = useLocation();

    const isChatPage = location.pathname.startsWith(CHAT_ROUTE);

    const { isLoggedIn, currentUserType } = useCurrentUser();


    return (
        <div>
            {!isChatPage && <footer className="bg-primary-50 py-10">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 gap-8">

                        <div className='flex flex-col md:flex-row gap-4 md:gap-10'>
                            {/* Logo & Description */}
                            <div>
                                <div>
                                    <img
                                        src={BRAND_ASSETS.LOGO}
                                        alt="Gamers Home Logo"
                                        className="h-10 mb-4"
                                    />
                                    <p className="text-sm mb-4">
                                        We manage freelancers and projects, you grow your business.
                                    </p>
                                </div>

                                {/* Contact Info */}
                                <div>
                                    <div className='flex space-x-4'>
                                        <p className='font-bold'>Contact Us:</p>
                                        <a href="mailto:info@gamershome.studio">info@gamershome.studio</a>
                                    </div>

                                    <p className="text-xs">
                                        1928, 1007 N Orange St. 4th Floor, Wilmington, DE, US
                                    </p>
                                </div>
                            </div>

                            <div className='flex flex-row md:flex-col gap-4 '>
                                <a onClick={goToPartnersAndAffiliates}>Our Partners</a>
                                {/* <a onClick={goToPartnersAndAffiliates}>Refer Talents</a>
                                <a onClick={goToPartnersAndAffiliates}>Refer Clients</a> */}
                                {isLoggedIn && currentUserType === EUserType.EMPLOYER && <a onClick={goToPricing}>Pricing</a>}
                            </div>
                        </div>

                        {/* Legal Links */}
                        <div className='flex flex-col md:flex-row gap-4'>
                            <a href='https://www.termsfeed.com/live/604a246e-5ce1-455d-b5ac-23d4ea2eb62b'>Privacy Policy</a>
                            <a href=''>Terms</a>
                            <a href=''>Refund Policy</a>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className='mt-8' />
                    <HorizontalSeparator />
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-xs">
                            Copyright © {new Date().getFullYear()} Gamers Home. All Rights Reserved.
                        </p>
                        <p className="text-xs text-primary">
                            Ecoworld Inc
                        </p>
                    </div>
                </div>
            </footer>}
        </div>
    );
};

export default Footer;
